import { memo, useCallback } from 'react'

import { Text } from '@cash-me/react-components'

import { Grid, Col } from 'components/grid'
import { SectionLabel } from 'components/section-label'
import { VideoPlayer } from 'components/video-player'
import { pushDataLayer } from 'utils/push-data-layer'

import * as S from './styles'

const VIDEO_URL = 'https://www.youtube-nocookie.com/embed/GLmkfGNEUXI?controls=0&autoplay=1'
const ABOUT_PAGE = '/quem-somos'
const VIDEO_THUMBNAIL = `${process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX}/images/site/home/about-us/thumbnail.png`

const AboutUs = memo(() => {
  const handleButtonClick = useCallback(() => {
    pushDataLayer({
      category: 'Clique',
      action: 'Sobre nós',
      label: 'Sobre nós - Conheça a CashMe'
    })
  }, [])

  const handleVideoClick = useCallback(() => {
    pushDataLayer({
      category: 'Clique',
      action: 'Sobre nós',
      label: 'Sobre nós - Vídeo Você conhece a CashMe'
    })
  }, [])

  return (
    <S.AboutUs>
      <Grid col={{ phone: 1, tablet: 1, desktop: 1 }}>
        <Col>
          <S.Container>
            <S.TextColumn>
              <S.Header>
                <SectionLabel
                  size="body1"
                  weight="bold"
                  color="white"
                  barColor="var(--colors-blue-border-strong-hover)"
                >
                  Sobre nós
                </SectionLabel>

                <Text as="h2" size="heading2" weight="medium" color="var(--colors-neutral-text-contrast-default)">
                  Por que a CashMe é a{' '}
                  <Text as="span" size="heading2" weight="medium" color="var(--colors-cyan-text-contrast)">
                    melhor escolha
                  </Text>{' '}
                  para você?
                </Text>
              </S.Header>

              <Text as="p" size="body1" weight="regular" color="var(--colors-neutral-text-contrast-default)">
                Porque é a fintech do Grupo Cyrela! Especialista em Crédito com Garantia de Imóvel, a CashMe oferece
                uma operação financeira segura para impulsionar os projetos mais importantes da sua vida e dos seus
                negócios.
              </Text>

              <S.ButtonWrapper>
                <S.ButtonLink href={ABOUT_PAGE} onClick={handleButtonClick}>
                  Conheça a CashMe
                </S.ButtonLink>
              </S.ButtonWrapper>
            </S.TextColumn>

            <S.VideoColumn>
              <S.VideoFrame onClick={handleVideoClick}>
                <VideoPlayer
                  videoUrl={VIDEO_URL}
                  videoTitle="Você conhece a CashMe?"
                  width={600}
                  height={338}
                  imagePlaceholder={VIDEO_THUMBNAIL}
                  alt="Conheça a CashMe, a fintech do Grupo Cyrela"
                />
              </S.VideoFrame>
            </S.VideoColumn>
          </S.Container>
        </Col>
      </Grid>
    </S.AboutUs>
  )
})

AboutUs.displayName = 'AboutUs'

export default AboutUs
